<template>
  <div class="page core_dialogue" :style="{ overflow: $route.path === '/Closingstatement1' && 'unset !important' }">
    <el-header v-if="$route.meta.isAuth && $route.path != '/Closingstatement1'">
      <img src="./assets/img/sclogo4.png" alt="" style="height: 60px" />
      <!-- <img src="@/assets/img/szjsxy.png" alt=""> -->
      <div class="homeExitContent">
        <!-- <el-button size="mini" @click="$store.commit('update',['userInfo',{userid:'2021400203',username:'yym',type:2}])">yym</el-button> -->
        <!-- <el-button size="mini" @click="$store.commit('update',['userInfo',{userid:'201901766',username:'qgt',type:0}])">qgt</el-button> -->
        <div
          class="Notify"
          @click="$store.commit('update', ['NotifyDig', true])"
        >
          <el-badge :is-dot="$store.state.Notify.length > 0" class="item">
            <span class="el-icon-s-opportunity"></span>
          </el-badge>
        </div>
        <div>你好，{{ $store.state.userInfo.username }}</div>
        <div class="homeExit" @click="homeExit">退出</div>
      </div>
    </el-header>
    <router-view></router-view>
    <el-dialog
      title="计划完成项目时间提醒"
      :visible.sync="$store.state.NotifyDig"
      width="60%"
      class="pageSubmitData"
    >
      <!-- 表格开始 -->
      <div style="width: 100%">
        <el-table
          ref="multipleTable"
          :data="$store.state.Notify"
          tooltip-effect="dark"
          width="100%"
          stripe
          class="fontSize"
          :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
        >
          <el-table-column prop="ProjectNo" label="项目编号" align="center">
          </el-table-column>
          <el-table-column prop="title" label="项目名称" align="center">
          </el-table-column>
          <el-table-column prop="name" label="分类" align="center">
          </el-table-column>
          <el-table-column prop="time" label="计划完成时间" align="center">
          </el-table-column>
          <el-table-column prop="Remaining" label="距离完结时间" align="center">
            <template #default="scope">
              <div>
                {{
                  scope.row.Remaining < 0
                    ? "已超时"
                    : scope.row.Remaining + "天"
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="operation" align="center" label="操作">
            <template #default="scope">
              <el-button
                type="primary"
                size="mini"
                @click="
                  lookDetail(scope.row, scope.row.courseId, scope.row.typeid)
                "
                >查看</el-button
              >
            </template>
          </el-table-column>
          <!-- selection-change批量选择功能后续可能用到 -->
          <!-- 
            <el-table-column
              type="selection"
              width="25"
              >
            
            </el-table-column> -->
          <!-- <el-table-column
              prop="ProjectNo"
              label="项目编号"
              align="center"
              min-width="9%"
            >
            </el-table-column>
            <el-table-column
              prop="title"
              label="项目名称"
              align="center"
              min-width="10%"
            >
            </el-table-column>
            <el-table-column
              prop="pro_leader"
              align="center"
              label="项目负责人"
              min-width="9%"
            >
            </el-table-column>
          
            <el-table-column
              prop="name"
              align="center"
              label="所在部门"
              min-width="10%"
            >
            </el-table-column>
            <el-table-column
              prop="sort"
              align="center"
              label="分类"
              min-width="10%"
            >
            </el-table-column> -->
        </el-table>
      </div>
      <!-- 表格结束 -->
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="$store.commit('update', ['NotifyDig', false])"
          class="AllDialogBtn"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    homeExit() {
      window.location.href = "http://10.16.30.130/sso/caslogout.jsp";
    },
    CleanStorage() {
      sessionStorage.clear();
    },
    lookDetail(r, val, tid) {
      //查看详情按钮
      // localStorage.setItem("pid",JSON.stringify(val))
      this.$store.commit("update", ["NotifyDig", false]);
      this.$router.push(`/projectApplicationDetailMain?tid=${tid}&pid=${val}`);
    },
  },
  mounted() {
    window.addEventListener("beforeunload", this.CleanStorage());
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.CleanStorage());
  },
};
</script>

<style lang="less">
.divCss {
  width: 100%;
  display: table-caption;
  height: 1930px;
  margin: 20px auto;
}
.divCss2 {
  width: 100%;
  display: table-caption;
}
// .divCss {
//   width: 100%;
//   height: 1850px;
//   overflow: hidden;
//   margin: 20px auto;
//   padding: 20px 0;
//   box-sizing: border-box;
//   display: flex;
//   align-items: center;
// }
// .divCss2 {
//   width: 100%;
//   display: table-caption;
// }
// .tableCss {
//   position: relative;
//   color: black;
//   width: 1200px;
//   margin: 0 auto;
//   margin-bottom: 20px;
//   font-size: 24px;
//   font-family: \5b8b\4f53;
//   tr {
//     width: 100%;
//     border: none;
//   }
//   tr td {
//     height: 60px;
//     width: 200px;
//     text-align: center;
//     box-sizing: border-box;
//     padding: 10px;
//     position: relative;
//     .textCss {
//       word-break: break-word;
//       white-space: pre-line;
//       line-height: 40px;
//     }
//     // :deep(.el-textarea.is-disabled .el-textarea__inner) {
//     //   background-color: unset;
//     //   border-color: unset;
//     //   color: rgb(0, 0, 0);
//     //   cursor: unset;
//     // }
//     .noFileBox {
//       width: 98%;
//       min-height: 200px;
//       display: flex;
//       flex-direction: column;
//       flex-wrap: nowrap;
//       align-items: flex-start;
//     }
//     .bigBlock {
//       width: 98%;
//       min-height: 200px;
//       display: flex;
//       flex-direction: column;
//       flex-wrap: nowrap;
//       align-items: flex-start;
//       border: 1px solid #cad1dc;
//       border-radius: 4px;
//       padding: 10px;
//       margin: 20px 0 0 0;
//       .fileBlock {
//         width: 98%;
//         margin-right: 20px;
//         position: relative;
//         border-radius: 5%;
//         padding: 5px 0 5px 0;
//         border-bottom: 1px solid #cad1dc;
//         .fileBox {
//           display: flex;
//           flex-direction: row;
//           flex-wrap: nowrap;
//           justify-content: space-between;
//           align-items: center;

//           .fileBoxLeft {
//             cursor: pointer;
//             display: flex;
//             flex-direction: row;
//             flex-wrap: nowrap;
//             align-items: center;
//             .chapter_upload_l_i3 {
//               width: 15px;
//               height: 15px;
//               background-repeat: no-repeat;
//               background-size: 100% 100%;
//               background-image: url("./assets/img/u_video.png");
//             }
//             .titName {
//               width: calc(100% - 15px);
//               white-space: nowrap;
//               overflow: hidden;
//               text-overflow: ellipsis;
//               word-break: break-word;
//               text-align: left;
//               margin-left: 10px;
//               max-width: 800px;
//             }
//           }
//           .fileBoxRight {
//             cursor: pointer;
//             display: flex;
//             flex-direction: row;
//             flex-wrap: nowrap;
//             align-items: center;
//             .chapter_upload_ic_r {
//               width: 18px;
//               height: 18px;
//               background-repeat: no-repeat;
//               background-size: 100% 100%;
//               background-image: url("./assets/img/delete_u.png");
//             }
//           }
//         }
//       }
//       .masking-out {
//         width: 100px;
//         height: 135px;
//         position: absolute;
//         top: 0;
//         left: 0;
//         display: none;
//         border-radius: 5%;
//         background: #00000053;
//         .delete {
//           cursor: pointer;
//           margin-left: 50%;
//           margin-top: 50%;
//           transform: translate(-50%, -50%);
//         }
//         .delete:hover {
//           color: #fff;
//         }
//       }
//       .fileBlock:hover .masking-out {
//         display: block;
//       }
//     }
//     p {
//       text-align: left;
//     }
//     :deep(.el-textarea__inner) {
//       border: none;
//       resize: none;
//       font-size: 18px;
//     }
//   }
// }
* {
  margin: 0;
  padding: 0;
}
html,
body {
  height: 100%;
  max-width: 100%;
  min-width: 700px;
  // overflow: hidden;
}
.textArea {
  font-size: 16px !important;
}
.page {
  //app最基础页面
  height: 100%;
  width: 100%;
  background: #e6eaf0;
  .el-header {
    //顶部退出区域
    background-color: #3d67bc;
    color: #333;
    text-align: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 70px;
    .homeExitContent {
      color: #fff;
      display: flex;
      justify-content: flex-end;
      width: 400px;
      .homeExit {
        background: #ffffff;
        color: #000;
        cursor: pointer;
        margin-left: 15px;
        width: 90px;
        // height: 30px;
      }
      .Notify {
        .item {
          margin-right: 50px;
          font-size: 1.1em;
          cursor: pointer;
        }
      }
    }
  }
}
hr {
  //hr横线
  border: none;
  height: 1px;
  width: 100%;
  margin: 0px 0px 10px 0px;
  background: #ccc;
}
.pdfTable {
  //查看详情已完结页面的下载pdf的table样式
  border: none;
  border-top: solid 1px black;
  // border-right:  solid 1px black;
  border-left: solid 1px black;
  position: relative;
  margin-top: 150px;
  margin-bottom: 120px;
  font-size: 20px;
  // width: 1200px;
  min-width: 1400px;
  max-width: 1400px;
  .jc {
    font-weight: 600;
  }
  .pdfTit {
    position: absolute;
    top: -140px;
    left: 50%;
    width: 100%;
    transform: translate(-50%);
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .school {
      font-weight: 600;
      font-size: 44px;
      letter-spacing: 10px;
    }
    .wordTitle {
      font-weight: 500;
      font-size: 32px;
      width: 100%;
      text-align: center;
      letter-spacing: 5px;
      margin-bottom: 10px;
    }
    .date {
      font-weight: bold;
      font-size: 20px;
      transform: translate(400px);
    }
  }

  .notes {
    position: absolute;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .checkAreaBlc {
		text-align: left;
		margin: 5px 0 5px 40px;
  }
  .textLeft {
    text-align: left;
    vertical-align: top;
    position: relative;
    max-width: 100%;
    height: 300px;
		.reviewComments{
			margin:30px 30px 80px 30px;
		}
    // white-space: nowrap;
    p:first-child {
      font-weight: 600;
    }
    div > p {
      font-weight: unset !important;
    }
    span > p {
      font-weight: unset !important;
    }
    span {
      // white-space: nowrap
      word-wrap: break-word;
      word-break: break-all;
    }
    :deep(.el-textarea__inner) {
      border: none;
      border-radius: 0px;
      text-align: left !important;
      font-size: 16px;
    }
  }
  tr {
    // position: relative;
    // height: 80px;
    td {
      border: none;
      border-bottom: solid 1px black;
      border-right: solid 1px black;
      height: 80px;
      text-align: center;
      line-height: 30px;
      min-width: 160px;
			max-width: 250px;
      box-sizing: border-box;
      padding: 5px;
      :deep(.el-select .el-input .el-select__caret) {
        display: none;
      }
      :deep(.el-textarea__inner) {
        // padding: 0;
        border: none;
        border-radius: 0px;
        text-align: center;
        font-size: 16px;
      }
      :deep(.el-input__inner) {
        border: none;
        border-radius: 0px;
        text-align: center;
        font-size: 16px;
      }
      :deep(input)::-webkit-outer-spin-button,
      :deep(input)::-webkit-inner-spin-button {
        -webkit-appearance: none;
      }
      :deep(input)[type="number"] {
        -moz-appearance: textfield;
      }
    }
  }
}

.exitTable {
  //所见所得填写项目的table样式
  border: none;
  border-top: solid 1px black;
  border-left: solid 1px black;
  position: relative;
  margin-top: 150px;
  margin-bottom: 120px;
  // font-size: 20px;
  width: 1200px;
  font-family: Arial, "Microsoft Yahe", "微软雅黑";
  .bold {
    font-weight: 600;
  }
  .pdfTit {
    position: absolute;
    top: -140px;
    left: 50%;
    width: 100%;
    transform: translate(-50%);
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .school {
      font-weight: 600;
      font-size: 30px;
      letter-spacing: 10px;
    }
    .wordTitle {
      font-weight: 500;
      font-size: 28px;
      width: 100%;
      text-align: center;
      letter-spacing: 5px;
      margin-bottom: 10px;
    }
    .date {
      font-weight: bold;
      font-size: 20px;
      transform: translate(400px);
    }
  }

  .textLeft {
    :deep(.el-textarea__inner) {
      border: none;
      border-radius: 0px;
      text-align: left !important;
      font-size: 16px;
    }
  }
  tr td {
    border: none;
    border-bottom: solid 1px black;
    border-right: solid 1px black;
    height: 40px;
    text-align: center;
    // line-height: 30px;
    min-width: 160px;
    box-sizing: border-box;
    padding: 5px;
    // &:last-of-type{
    //   border-right:  solid 1px black;
    // }
    p {
      font-weight: 600;
    }
    :deep(.el-select .el-input .el-select__caret) {
      display: none;
      font-family: Arial, "Microsoft Yahe", "微软雅黑";
    }
    :deep(.el-textarea__inner) {
      // padding: 0;
      border: none;
      // outline: none;
      border-radius: 0px;
      text-align: center;
      font-size: 16px;
      font-family: Arial, "Microsoft Yahe", "微软雅黑";
    }
    :deep(.el-input__inner) {
      border: none;
      border-radius: 0px;
      text-align: center;
      font-size: 16px;
      font-family: Arial, "Microsoft Yahe", "微软雅黑";
    }
    :deep(input)::-webkit-outer-spin-button,
    :deep(input)::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
    :deep(input)[type="number"] {
      -moz-appearance: textfield;
    }
  }

  .notes {
    width: 100%;
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 0;
    bottom: -100px;
    // justify-content: flex-start;
    text-align: left;
    // margin-bottom: 30px;
  }
}

.pAHeader {
  //一级页面一级标题

  width: 100%;
  display: flex;
  height: 35px;
  justify-content: space-between;
  margin-bottom: 15px;
  .pAHeader1 {
    font-weight: 600;
    font-size: 26px;
    text-align: left;
  }
  [type="button"] {
    background: #0e72e6 !important;
    color: #fff !important;
    display: flex;
    font-size: 16px;
    display: flex;
    border-radius: 5px;
    justify-content: center;
    align-items: center;
  }
  [type="button"]:hover {
    background: #3b85d9 !important;
  }
}

.vfpHeader {
  //二级页面一级标题

  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 15px;
  position: relative;
  .titleOne {
    text-align: left;
    font-weight: 600;
    font-size: 22px;
    flex-shrink: 0;
  }
  .smallTitle {
    position: absolute;
    top: 8px;
    left: 160px;
    font-size: 16px;
  }
  [type="button"] {
    background: #0e72e6 !important;
    color: #fff !important;
    display: flex;
    position: absolute;
    top: -8px;
    right: 0;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 9px 0;
    justify-content: center;
    font-size: 16px;
    width: 100px;
    align-items: center;
  }
}

.tabTit {
  //二级页面二级标题

  width: 100%;
  font-size: 18px;
  font-weight: bold;
  margin-top: 40px;
  height: 29px;
  margin-bottom: 15px;
  display: flex;
  text-align: end;
  border-radius: 5px;
  position: relative;
  justify-content: space-between;
  align-items: flex-end;
  div {
    position: absolute;
    left: 0;
    bottom: 0;
    text-align: left;
    display: flex;
    align-items: flex-end;
    p {
      position: relative;
      width: auto;
    }
    span {
      font-size: 14px;
      margin-left: 10px;
      color: gray;
    }
  }
  [type="button"] {
    color: #fff !important;
    display: flex;
    position: absolute;
    right: 0;
    top: -4px;
    box-sizing: border-box;
    padding: 7px 0;
    justify-content: center;
    font-size: 16px;
    width: 100px;
    border-radius: 5px;
    align-items: center;
  }
}

// 滚动条样式
.core_dialogue {
  height: 100%;
  overflow: overlay !important;
}
.core_dialogue::-webkit-scrollbar-track-piece {
  background-color: #f8f8f800;
}
.core_dialogue::-webkit-scrollbar {
  width: 6px;
  transition: all 2s;
}
.core_dialogue::-webkit-scrollbar-thumb {
  background-color: #929292;
  border-radius: 100px;
}
.core_dialogue::-webkit-scrollbar-thumb:hover {
  background-color: #bbb;
}
.core_dialogue::-webkit-scrollbar-corner {
  background-color: rgba(255, 255, 255, 0);
}

.AppBar {
  //横行的跳转导航栏

  display: flex;
  margin-top: 15px;
  margin-bottom: 20px;
  div {
    // width: 110px;
    cursor: pointer;
    font-weight: 550;
    font-size: 18px;
    margin-right: 30px;
    position: relative;
    .pr1TitBass {
      // position: absolute;
      // width: 100%;
      // height: 4px;
      // left: 0;
      // top: 28px;
      // border-radius: 2px;
      // background: #2a7ea9;
      position: absolute;
      width: 100%;
      height: 4px;
      left: 0;
      top: 30px;
      border-radius: 2px;
      background: #2a7ea9;
    }
  }
  // .AppBarActive::after{

  // }
}

.AddMember {
  //添加成员对话框

  .el-input__inner {
    width: 300px;
  }
  .el-dialog {
    width: 600px;
    border-radius: 5px;
    overflow: hidden;
  }

  .el-dialog__body {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .el-dialog__header {
    background: #32455b;
    text-align: center;
  }
  .el-dialog__title {
    color: #fff;
    position: relative;
    top: -2px;
    font-size: 18px;
  }
  .littleBlock {
    //添加对话框 label和input框
    display: flex;
    // width: 70%;
    justify-content: center;
    width: 100%;
    margin: 10px;
    .dialogLabel {
      //label
      width: 14%;
      font-size: 16px;
      align-items: center;
      margin-right: 10px;
      line-height: 25px;
      display: inline-block;
      text-align: justify;
      text-justify: distribute-all-lines;
      text-align-last: justify;
    }
  }
  .littleBlock:nth-last-of-type(-n + 2) {
    // line-height: 20px !important;
    // color: #0e72e6;
    display: flex;
    align-items: center;
  }
  .el-dialog__footer {
    padding-top: 0;
  }
  .footer {
    width: 100%;
    display: flex;
    justify-content: center;
    [type="button"] {
      font-size: 16px;
    }
  }
}

.selects {
  //一级页面搜索框，不包含项目管理、成果展示

  width: 100%;
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px 0 10px;
  .selectsBlock {
    display: flex;
    margin-right: 30px;
    margin-bottom: 20px;
  }
  .selectLabel {
    width: 64px;
    font-size: 16px;
    margin-right: 10px;
    display: inline-block;
    font-weight: bolder;
    text-align: justify;
    text-justify: distribute-all-lines;
    text-align-last: justify;
    transform: translate(0, 22%);
  }
}

.selectInp {
  // 一级页面搜索框 项目管理、成果展示

  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  position: relative;
  width: 99%;
  .manageSelects {
    display: flex;
    flex-wrap: wrap;
    width: 80%;
    .selectsBlock {
      display: flex;
      margin-right: 30px;
      margin-bottom: 20px;
    }
    .selectLabel {
      width: 64px;
      font-size: 16px;
      margin-right: 10px;
      display: inline-block;
      font-weight: bolder;
      text-align: justify;
      text-justify: distribute-all-lines;
      text-align-last: justify;
      transform: translate(0, 22%);
    }
  }
  .ProjectManagementQuery {
    display: flex;
    position: absolute;
    right: 0;
    .btn {
      font-size: 16px;
      margin-left: 10px;
      background: #2268bc;
    }
  }
}

.twoSelectInp {
  //一级页面搜索框 创业公司登记、消息提示
  width: 100%;

  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 10px;
  .selectTwo {
    display: flex;
    flex-wrap: wrap;
    width: 80%;
    .selectsBlock {
      margin-bottom: 5px;
      .btn2 {
        font-size: 14px;
        margin-left: 10px;
        background: #2268bc;
      }
    }
  }
}

.inputNumber {
  //输入框只能数字
  /* 普通IE浏览器 样式清除 */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }
  /* 火狐浏览器样式清除 */
  input[type="number"] {
    -moz-appearance: textfield;
  }
}

.disa {
  //禁用按钮样式
  background-color: #c8c9cc !important;
  border-color: #c8c9cc;
  cursor: no-drop !important;
}
.fontSize {
  //所有表格字体大小

  margin-top: 15px;
  // margin-bottom: 60px;
  font-size: 16px !important;
  .operations {
    //所有表格按钮栏
    display: flex;
    justify-content: flex-start;
    flex-wrap: nowrap;
    [type="button"] {
      width: 80px !important;
      font-size: 14px;
      margin-right: 3%;
      border: none;
      box-sizing: border-box;
      border-radius: 5px;
      padding: 8px 0;
    }
  }
}
.paginations {
  //分页栏

  position: relative;
  display: flex;
  justify-content: flex-end;
  margin: 20px 50px 0 0;
  right: 30px;
  bottom: 0;
}

.showFileArea {
  //在线查看文档内容居中

  width: 100%;
  height: 100%;
  // height: 70vh;
  display: flex;
  justify-content: center;
}

.editor {
  //显示栏

  width: 100%;
  box-sizing: border-box;
  padding: 15px 0px 10px 0px;
}

.pageSubmitData {
  //页面提交数据,删除成员，审核对话框样式

  .el-dialog__header {
    display: flex;
    justify-content: center;
  }
  .el-dialog {
    border-radius: 5px;
    overflow: hidden;
    top: 10%;
  }
  .el-dialog__body {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    height: 100%;
    align-items: center;
  }
  .el-input.is-disabled .el-input__inner {
    color: #000;
  }
  .deleteContent {
    width: 100%;
    text-align: center;
    font-size: 18px;
    color: #000;
  }
  .addDialogLogo {
    width: 60px;
    height: 30px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    line-height: 30px;
    background: #f2f2f2;
    position: absolute;
    left: 20px;
    top: 15px;
  }
  .el-dialog__header {
    background: #32455b;
  }
  .el-dialog__title {
    color: #fff;
    display: flex;
    justify-content: center;
    font-size: 18px;
    position: relative;
    top: -2px;
  }
  .diaTit {
    //项目名称、负责人
    width: 100%;
    display: flex;
    box-sizing: border-box;
    padding: 0 50px;
		justify-content: center;
    .spans {
      width: auto;
      font-size: 16px;
      // margin-right: 10px;
      display: inline-block;
      text-align: justify;
      color: #000;
      font-size: 16px;
      text-justify: distribute-all-lines;
      text-align-last: justify;
      transform: translate(0, 22%);
      margin-bottom: 10px;
    }
    .spanCon {
      font-size: 16px;
      margin-top: 5px;
      color: #a0a0a0;
      width: 150px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .diaTit1 {
    //label和input框
    display: flex;
    width: 80%;
    margin-top: 20px;
		justify-content: center;
    .inp {
      width: 100%;
    }
    .spans1 {
      //label
      min-width: 84px;
      font-size: 16px;
      color: #000;
      margin-right: 10px;
      display: inline-block;
      text-align: justify;
      text-justify: distribute-all-lines;
      text-align-last: justify;
      transform: translate(0, 22%);
    }
  }
  //   .addDialogMid{
  //     box-sizing: border-box;
  //     padding:0 60px 0 10px;
  //     .addDialogTit{
  //       display: flex;
  //       span{
  //         width: 80px;
  //         line-height: 40px;
  //         text-align: left;
  //       }
  //     }
  //     .addDialogTit1{
  //       display: flex;
  //       justify-content: space-between;
  //       margin-bottom: 15px;
  //     }
  //     .addDialogTit2{
  //       margin-top: 10px;
  //       font-size: 18px;
  //       color: #000;
  //       text-indent: 2em;
  //     }
  //     .addDialogCon{
  //       margin-top: 20px;
  //     }
  // }
  .dialog-footer {
    display: flex;
    justify-content: center;
  }
}

.DialogBox {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: relative;
  width: 100%;
  height: 100%;
  // background-color: red;
  .DialogTitle {
    color: white;
    font-size: 18px;
  }
  .changeFull {
    color: gray;
    cursor: pointer;
    position: absolute;
    right: 3%;
    font-size: 1em;
    &:hover {
      color: white;
    }
  }
}

.select {
  //活动申请填写信息区域（没用）

  width: 100%;
  box-sizing: border-box;
  margin-top: 30px;
  // margin-bottom: 8px;
  .label {
    //label标签
    min-width: 98px;
    margin-right: 5px;
    display: inline-block;
    text-align: justify;
    text-justify: distribute-all-lines;
    text-align-last: justify;
    transform: translate(0, 22%);
    padding-right: 15px;
    font-size: 16px;
  }
  .inpBlock {
    //一个个输入框小方块

    display: flex;
    margin-bottom: 15px;
    position: relative;
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none !important;
    }
    input[type="number"] {
      -moz-appearance: textfield;
    }
  }

  .selectTop {
    width: 86%;
    display: flex;
  }

  .selectMid {
    display: flex;
    margin-top: 16px;

    .selectLeft {
      width: 40%;
      display: flex;
      flex-direction: column;
      margin-right: 70px;
      // align-items: center;
    }
    .selectRight {
      width: 40%;
      height: 150px;
      display: flex;
      flex-direction: column;
      .el-cascader {
        width: 100%;
      }
    }
  }
}

.AllDialogBtn {
  //所有对话框按钮（好像没用）

  width: 120px;
  font-size: 16px !important;
}

.pTit {
  //项目详情类大标题（好像没用）

  color: #3994ff;
  font-weight: 550;
  font-size: 18px;
  margin: 15px 0;
}

.pTit2 {
  //项目详情类小标题（好像没用）

  margin-top: 15px;
  color: #3994ff;
  font-weight: 550;
  font-size: 16px;
}

.addMoneyBtn {
  //自定义写的的添加框 （没用）

  width: 120px;
  cursor: pointer;
  height: 40px;
  border: #000 1px dashed;
  border-radius: 5px;
  margin: 18px 10px 30px;
  display: flex;
  justify-content: center;
  line-height: 40px;
  font-size: 16px;
  position: relative;
  .jia {
    border-radius: 50%;
    border: 1.5px #ccc solid;
    font-size: 25px;
    line-height: 26px;
    font-weight: 10;
    display: flex;
    justify-content: center;
    margin-top: 6px;
    margin-right: 5px;
    height: 27px;
    width: 27px;
    color: #ccc;
  }
  #upFile {
    position: absolute;
    width: 100%;
    height: 100%;
    transform: scale(1.1, 1.1);
    opacity: 0;
  }
}

.baseBtn {
  //所有页面底部按钮框（好像没用）

  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 10px 0;
  margin-top: 30px;
  .blockWidth {
    display: flex;
    justify-content: space-between;
    [type="button"] {
      background: #409eff;
      color: #fff !important;
      display: flex;
      border: none;
      justify-content: center;
      font-size: 16px;
      width: 120px;
      margin-left: 20px;
      height: 40px;
      align-items: center;
    }
  }
}

.twoStyle {
  //左边两边对齐，右边靠右的靠右样式资金管理页面里的（没用）

  display: flex !important;
  justify-content: flex-end;
}
</style>
